import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { SkillConfigurationRemoteDto } from 'src/generated/signalR/skill-configuration-remote-dto';
import { SkillDiversionTargetRemoteDto } from 'src/generated/signalR/skill-diversion-target-remote-dto';
import { SkillRealtimeRemoteDto } from 'src/generated/signalR/skill-realtime-remote-dto';
import { SkillUserConfigurationRemoteDto } from 'src/generated/signalR/skill-user-configuration-remote-dto';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';
import { IBrickInstanceTargetingAction } from '../../utility/IBrickInstanceTargetingAction';
import { SamwinSkillTypeEnum } from './samwin-skills-type-enum';

export class SkillRealtimeDataChanged {
   public static readonly type = '[Samwin Skills] skill realtime data changed';

   constructor(public skillRealtimeData: SkillRealtimeRemoteDto[]) {}
}

export class SkillConfigurationChanged {
   public static readonly type = '[Samwin Skills] skill configuration changed';

   constructor(public skillConfiguration: SkillConfigurationRemoteDto[]) {}
}

export class SkillUserConfigurationChanged {
   public static readonly type = '[Samwin Skills] skill user configuration changed';

   constructor(public skillUserConfiguration: SkillUserConfigurationRemoteDto[]) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.SKILLS)
export class ChangeSkillStatus implements IBrickInstanceTargetingAction {
   public static readonly type = '[Samwin Skills] change skill status';

   constructor(
      public skillId: number,
      public shouldSkillBeActive: boolean,
      public brickInstanceId: string,
      public skillType: SamwinSkillTypeEnum = SamwinSkillTypeEnum.CALLING
   ) {}
}

export class RegisterForForeignSkillInfos {
   public static readonly type = '[Samwin Skills] Register for foreign skill infos';

   constructor(public skillIds: number[]) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.SKILLS)
export class RedirectSkill implements IBrickInstanceTargetingAction {
   public static readonly type = '[Samwin Skills] redirect skill';

   constructor(public skillId: number, public diversionAddress: string, public brickInstanceId: string) {}
}

export class PermittedSkillDiversionUpdated {
   public static readonly type = '[Samwin Skills] permitted skill diversions updated';

   constructor(public permittedSkillDiversions: SkillDiversionTargetRemoteDto[]) {}
}
